/**
 * Förhandlingsordning — Avtalstid rules (ADR-0101).
 *
 *   1. start before today                  → W, no fix
 *   2. fixed term, not exactly one year    → W "kortare/längre än ett år", fix
 *   3. end before start                    → E, fix
 *   4. fixed term shorter than one month   → W, fix
 *
 * Precedence: 3 alone when it fires; 4 suppresses 2.
 */
import { parseIsoDate, periodEnd } from '@hyranai/regta-document-ir';
import { pickCode } from '../common/index.js';
const START = 'agreement_start_date';
const END = 'agreement_end_date';
const TERM = 'agreement_term';
export function avtalstidRules(input, ctx, termOptions) {
    const start = parseIsoDate(input[START]);
    const tillsvidare = pickCode(termOptions, input[TERM]) === 'tillsvidare';
    const end = tillsvidare ? null : parseIsoDate(input[END]);
    const oneYear = start ? { label: 'Sätt till ett år', set: { [END]: periodEnd(start, 12) } } : undefined;
    const periodKeys = [END, START, TERM];
    if (start && end && end < start) {
        return [
            {
                ruleId: 'end_before_start',
                slotKeys: periodKeys,
                severity: 'error',
                message: 'Avtalsslut måste vara efter avtalsstart',
                ...(oneYear ? { fix: oneYear } : {}),
            },
        ];
    }
    const out = [];
    if (start && start < ctx.today) {
        out.push({
            ruleId: 'start_passed',
            slotKeys: [START],
            severity: 'warning',
            message: 'Notera att datumet (för avtalsstart) har passerat',
        });
    }
    if (start && end) {
        const yearEnd = periodEnd(start, 12);
        if (end < periodEnd(start, 1)) {
            out.push({
                ruleId: 'period_short',
                slotKeys: periodKeys,
                severity: 'warning',
                message: 'Avtalstiden är kort, vanligt är ett år',
                fix: oneYear,
            });
        }
        else if (end !== yearEnd) {
            out.push({
                ruleId: 'period_not_one_year',
                slotKeys: periodKeys,
                severity: 'warning',
                message: end < yearEnd ? 'Perioden är kortare än ett år' : 'Perioden är längre än ett år',
                fix: oneYear,
            });
        }
    }
    return out;
}
//# sourceMappingURL=validation.js.map